import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';
import { Layout } from 'antd';
import { Permission } from '../../types/Auth';
import { PrivateRoute, NotFound } from '../public';
import { AppHeader, AppSidebar, AppContentWrapper } from '../../components/Layout';

import { AppLayoutProvider } from '../../contexts/AppLayout/AppLayoutProvider';

// Application Nested Views...
import Client from '../Client/Client';
import Job from '../Job/Job';
import Stack from '../Stack/Stack';
import LogsView from '../LogsView/LogsView';

const Home: React.FC = (): React.ReactElement => {
    const routeMatch = useRouteMatch();
    return (
        <>
            <AppLayoutProvider>
                <AppHeader />
                <Layout>
                    <AppSidebar />
                    <AppContentWrapper>
                        <Switch>
                            <Redirect exact from={`${routeMatch.path}`} to={`${routeMatch.path}/clients`} />
                            <PrivateRoute
                                path={`${routeMatch.path}/clients`}
                                comp={Client}
                                perm={Permission.CLIENT_PAGE_VIEW}
                            />
                            <PrivateRoute path={`${routeMatch.path}/jobs`} comp={Job} perm={Permission.JOB_PAGE_VIEW} />
                            <PrivateRoute
                                path={`${routeMatch.path}/stacks`}
                                comp={Stack}
                                perm={Permission.JOB_PAGE_VIEW}
                            />
                            <PrivateRoute
                                path={`${routeMatch.path}/logs`}
                                comp={LogsView}
                                perm={Permission.CLIENT_PAGE_VIEW}
                            />
                            <Route path="*" component={NotFound} />
                        </Switch>
                    </AppContentWrapper>
                </Layout>
            </AppLayoutProvider>
        </>
    );
};

export default Home;
